<div *ngIf="highlightsProducts.length">
  <div class="highlightSection" style="padding: 40px 60px 0 50px; position: relative">
    <!-- highlights-->
    <!-- <h1 class="text-center">{{ 'Learn more' | translate }}</h1> -->
    <h2 class="homeHeadingSection">
      <span class="inter-font">{{ 'Learn' | translate }}</span
      ><span class="cavet-font" style="margin-left: 10px">{{ 'more' | translate }}</span>
    </h2>
    <!-- <h5 class="text-center homepage-desc">{{ 'HighlightDesc' | translate }}</h5> -->
    <p class="homepage-desc latestVideosSectionP">{{ 'HighlightDesc' | translate }}</p>
    <div class="card" style="background-color: transparent; border: 0">
      <div>
        <p-carousel
          [value]="highlightsProducts"
          styleClass="custom-carousel"
          [numVisible]="4"
          [numScroll]="1"
          [circular]="true"
          [responsiveOptions]="responsiveOptions"
          [ngClass]="language"
          aria-hidden="true"
        >
          <ng-template let-product pTemplate="item">
            <a target="_blank" [href]="product.url" style="text-decoration: none; color: rgb(33, 37, 41)">
              <div class="product-item slider-arrow">
                <div class="product-item-content">
                  <div class="image parr-image" [style.background-image]="'url(' + product.uri + ')'">
                    <img [src]="" [alt]="product.title" class="product-image slider-image" />
                  </div>
                  <div class="title" *ngIf="product.specialInterestName">
                    <i class="{{ product.specialIntersetIcon }}"></i>
                    <span>{{ product.specialInterestName | translate | uppercase }}</span>
                  </div>
                </div>
              </div>
              <div class="text mt-2">
                <p class="p-r-15">{{ product.title }}</p>
              </div>
            </a>
          </ng-template>
        </p-carousel>
      </div>
      <div class="viewall-btn homeviewall-btn">
        <a href="/blog">{{ 'View All' | translate }}<i class="pi pi-angle-right"></i></a>
      </div>
    </div>
  </div>
</div>
<!-- //highlights-->
